import WebsiteElement from "./WebsiteElement";
import Rellax from "rellax";
import CoverBlock from "./CoverBlock";

export default class PostCoverBlock extends CoverBlock {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        super(element);

        /**
         * @type {NodeListOf<HTMLElementTagNameMap[string]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[string]>}
         */
        this.parallaxElements = this._element.querySelectorAll('h1, p, .wp-block-button');

        /**
         * @type {*[]}
         */
        this.relaxInstances = [];

        this.setupParallax();
    }

    setupParallax() {
        const speeds = [
            4,
            3,
            2
        ];

        this.parallaxElements.forEach((element, index) => {
            const instance = new Rellax(element, {
                speed: speeds[index],
                wrapper: null,
                round: true,
            });

            this.relaxInstances.push(instance);
        });
    }

    /**
     * @param {HTMLElement} element
     */
    static is(element) {
        return element.classList.contains('wp-block-cover') && element.classList.contains('is-style-post');
    }
}